import { render } from "./OmOs.vue?vue&type=template&id=7efec548"
import script from "./OmOs.vue?vue&type=script&lang=js"
export * from "./OmOs.vue?vue&type=script&lang=js"

import "./OmOs.vue?vue&type=style&index=0&id=7efec548&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__